// A mock function to mimic making an async request for data
import { handleErrorResp, httpClient } from "../../../Service/Service";

export async function loginUser(
  email: string,
  password: string,
  login_type: string,
  mobile: number
) {
  try {
    const response = await httpClient<any>(`user/login`, "POST", {
      email,
      password,
      login_type,
      mobile
    });
    console.info("response", response);
    return response;
  } catch (err) {
    console.error("Login Error:", err);
    return handleErrorResp(err);
  }
}
